import { IFieldSchema } from "../interfaces/IFieldSchema";
import { AddToModelParamList, FIELD } from "../utils";

/**
 * Decorator that will determine a field on the database model
 * 
 * @param options?: IFieldSchema
 *   The options this field should use when building out the database model
 * @return Function
 *   Will return a function that will be used by the Reflection API to build out everything on the object
 */
export function Field(options?: IFieldSchema) {
    options = options || {};
    return (target: any, propertyKey: string) => {
        AddToModelParamList(target, propertyKey);
        options.type = options.type || Reflect.getMetadata("design:type", target, propertyKey);
        options.name = propertyKey;
        Reflect.defineMetadata(FIELD, options, target, propertyKey);
    };
}